import application from 'application/application';

import template from './account.template.html';

import controller from './account.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.account', {
				url: '/meus-dados',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Partner',
					displayName: 'Meus dados'
				}
			});

	}]);
